export const toFraction = (value: number | string | undefined) => {
    return Math.floor((typeof value === 'string' ? parseFloat(value) : value || 0) * 100) / 100;
};
